// Angular
import { NgModule, LOCALE_ID } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";

// Kendo
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { ComboBoxModule } from "@progress/kendo-angular-dropdowns";
import { CalendarModule } from "@progress/kendo-angular-dateinputs";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import {
  DialogModule,
  WindowComponent,
  WindowContainerService,
  WindowModule,
  WindowService,
} from "@progress/kendo-angular-dialog";

import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { ExcelModule } from "@progress/kendo-angular-grid";
import { GridModule } from "@progress/kendo-angular-grid";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from "@progress/kendo-angular-label";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { MultiSelectModule } from "@progress/kendo-angular-dropdowns";
import { PDFModule } from "@progress/kendo-angular-grid";
import { SchedulerModule } from "@progress/kendo-angular-scheduler";
import { UploadModule } from "@progress/kendo-angular-upload";
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';

// ngx-bootstrap
import { CarouselModule } from "ngx-bootstrap/carousel";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CollapseModule } from "ngx-bootstrap/collapse";

// Components
import { PreloaderComponent } from "app/_components/preloader/preloader.component";
import { TileComponent } from "app/_components/tile/tile.component";
import { IntakeTitleIconComponent } from "app/_components/title/intake-title-icon/intake-title-icon.component";

// Services
import { AuthService } from "app/_services";
import { EntryService } from "app/_services";
import { WISEService } from "app/_services";
import { LossAdjusterService } from "app/_services";

// Sprockets
import { ReloadSprocketComponent } from "app/_components/sprockets/reload.sprocket";

// Directives
import { HasRoleDirective } from "app/_directives/hasrole.directive";
import { SortDirective } from "app/_directives/sort.directive";
import { AutoResizeDirective } from "app/_directives/autoresize.directive";
import { NumericDirective } from "app/_directives/numeric.directive";
import { DefaultImageDirective } from "app/_directives/default-image.directive";
import { IbanValidatorDirective } from "app/_directives/iban-validator.directive";

// Config
import { BOOTSTRAP_FORMLY_CONFIG } from "./formly.config";

// ngx-translate
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";

// grid
import { GridUniversalCalculation } from "app/_components/grid/universalcalculation.grid.component";
import { GridUniversalCalculationView } from "app/_components/grid/universalcalculation-view.grid.component";

// grid form
import { GridEditFormComponent } from "app/_components/form/grid-edit-form-universalcalculation.component";

// formly
import { FormlyModule } from "@ngx-formly/core";
import { FormlyExtension } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { FormlyTabsModule } from "ngx-formly-tabs";

// formly components
import { CardWrapperComponent } from "app/_components/formly/wrappers";
import { PanelWrapperComponent } from "app/_components/formly/wrappers";
import { SectionWrapperComponent } from "app/_components/formly/wrappers";
import { FormHorizontalWrapperComponent } from "app/_components/formly/wrappers";
import { PrintBreakWrapperComponent } from "app/_components/formly/wrappers";
import { FormlyFieldInput } from "app/_components/formly/types";
import { FormlyFieldInputIBAN } from "app/_components/formly/types";
import { FormlyFieldTextArea } from "app/_components/formly/types";
import { FormlyFieldText } from "app/_components/formly/types";
import { FormlyFieldPoliceRegion } from "app/_components/formly/types";
import { FormlyFieldKendoMultiSelect } from "app/_components/formly/types";
import { FormlyFieldRadio } from "app/_components/formly/types";
import { FormlyFieldCheckBox } from "app/_components/formly/types";
import { FormlyFieldDate } from "app/_components/formly/types";
import { FormlyFieldGridAfmetingen } from "app/_components/formly/types";
import { FormlyFieldMultiCheckbox } from "app/_components/formly/types";
import { FormlyFieldRepeat } from "app/_components/formly/types";
import { RepeatTypeComponent } from "app/_components/formly/types";

// pipe
import { OrderByPipe } from "app/_common/orderbypipe.pipe";

// 3rd party
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxFontAwesomeModule } from "ngx-font-awesome";
import { DEFAULT_CONFIG, NgForageOptions } from "ngforage";
import { CountUpModule } from "countup.js-angular2";
import { SidebarModule } from "ng-sidebar";
import { LightboxModule } from "ngx-lightbox";
import { DataTablesModule } from "angular-datatables";
import { LocalForageModule } from "ngx-localforage";
//import { Ng8DataTableModule } from 'ng8-data-table';
import { SignPadModule } from "ngx-sign-pad";
import { WebcamModule } from "ngx-webcam";

import { GooglePlaceModule } from "ngx-google-places-autocomplete";

import { load } from "@progress/kendo-angular-intl";

// Load all required data for the bg locale
import "@progress/kendo-angular-intl/locales/nl/all";
import { EditorModule } from "@progress/kendo-angular-editor"

// local
import * as likelySubtags from 'cldr-data/supplemental/likelySubtags.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';
import * as currencyData from 'cldr-data/supplemental/currencyData.json';
import * as numbers from 'cldr-data/main/nl/numbers.json';
import * as timeZoneNames from 'cldr-data/main/nl/timeZoneNames.json';
import * as calendar from 'cldr-data/main/nl/ca-gregorian.json';
import * as currencies from 'cldr-data/main/nl/currencies.json';
import * as dateFields from 'cldr-data/main/nl/dateFields.json';
import { CedConfirmDialogModule, CedTabLayoutModule,CedNotificationModule, CedTreeViewModule } from "ced-ng-library";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { PureCloudDialDirective } from "app/_directives/pure-cloud-dial.directive";

load(
  likelySubtags,
  weekData,
  currencyData,
  numbers,
  currencies,
  calendar,
  dateFields,
  timeZoneNames
);
// Constants
const ngfRootOptions: NgForageOptions = {
  name: "DatabaseName1",
  storeName: "App",
};

export function TranslateHttpFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


@NgModule({
  imports: [
    CedNotificationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(BOOTSTRAP_FORMLY_CONFIG),
    FormlySelectModule,
    FormlyTabsModule,
    NgxFontAwesomeModule,
    FontAwesomeModule,
    CountUpModule,
    ButtonsModule, // kendo start
    ComboBoxModule,
    DateInputsModule,
    DialogModule,
    DropDownsModule,
    ExcelModule,
    GridModule,
    InputsModule,
    IntlModule,
    LabelModule,
    MultiSelectModule,
    PDFModule,
    SchedulerModule,
    UploadModule,
    CalendarModule,
    DateInputsModule,
    LayoutModule, // kendo end
    SidebarModule.forRoot(),
    CarouselModule.forRoot(),
    TabsModule.forRoot(),
    CollapseModule.forRoot(),
    LocalForageModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateHttpFactory,
        deps: [HttpClient],
      },
      extend: true
    }),
    SignPadModule,
    WebcamModule,
    LightboxModule,
    DataTablesModule,
    //Ng8DataTableModule,
    WindowModule,
    DatePickerModule,
    TreeViewModule,
    CedTreeViewModule,
    GooglePlaceModule,
    CedConfirmDialogModule,
    ListViewModule,
    EditorModule
  ],
  entryComponents: [],
  declarations: [
    TileComponent,
    IntakeTitleIconComponent,
    PreloaderComponent,
    ReloadSprocketComponent,
    HasRoleDirective,
    SortDirective,
    AutoResizeDirective,
    NumericDirective,
    DefaultImageDirective,
    IbanValidatorDirective,
    GridUniversalCalculation,
    GridUniversalCalculationView,
    GridEditFormComponent,
    CardWrapperComponent,
    PanelWrapperComponent,
    PrintBreakWrapperComponent,
    SectionWrapperComponent,
    FormHorizontalWrapperComponent,
    FormlyFieldInput,
    FormlyFieldInputIBAN,
    FormlyFieldTextArea,
    FormlyFieldText,
    FormlyFieldPoliceRegion,
    FormlyFieldKendoMultiSelect,
    FormlyFieldRadio,
    FormlyFieldCheckBox,
    FormlyFieldDate,
    FormlyFieldGridAfmetingen,
    FormlyFieldMultiCheckbox,
    FormlyFieldRepeat,
    RepeatTypeComponent,
    OrderByPipe,
    PureCloudDialDirective
  ],
  providers: [
    {
      provide: DEFAULT_CONFIG,
      useValue: ngfRootOptions,
    },
    {
      provide: LOCALE_ID,
      useValue: "nl",
    },
    AuthService,
    EntryService,
    EntryService,
    WISEService,
    LossAdjusterService,
    WindowService,
    WindowContainerService,
  ],
  exports: [
    CedNotificationModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
    FormlyTabsModule,
    GridUniversalCalculation,
    GridUniversalCalculationView,
    GridEditFormComponent,
    PreloaderComponent,
    TileComponent,
    IntakeTitleIconComponent,
    ReloadSprocketComponent,
    HasRoleDirective,
    SortDirective,
    AutoResizeDirective,
    NumericDirective,
    DefaultImageDirective,
    NgxFontAwesomeModule,
    FontAwesomeModule,
    CountUpModule,
    ButtonsModule, // kendo start
    ComboBoxModule,
    DateInputsModule,
    DialogModule,
    DropDownsModule,
    ExcelModule,
    GridModule,
    InputsModule,
    IntlModule,
    LabelModule,
    MultiSelectModule,
    PDFModule,
    SchedulerModule,
    UploadModule,
    LayoutModule, // kendo end
    SidebarModule,
    CarouselModule,
    TabsModule,
    CollapseModule,
    LightboxModule,
    SignPadModule,
    WebcamModule,
    DataTablesModule,
    GooglePlaceModule,
    TranslateModule,
    //Ng8DataTableModule,
    CedTabLayoutModule,
    ListViewModule,
    EditorModule,
    CedTreeViewModule,
    TreeViewModule,
    PureCloudDialDirective
  ],
})
export class SharedModule { }